module.exports = __webpack_public_path__ + "img/merch-1.4ec651ef.png";